module.exports = __webpack_public_path__ + "img/shop-icon.a7e04f92.jpg";